import React from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { CATEGORIES } from './../../../constants'

import { Form, SelectInput } from '../../UI'

import { validateRequired } from './../../../libs/validation'
import { NotificationManager } from 'react-notifications'

import UPDATE_PLANNER_PROFILE_CATEGORIES_QUERY from './../../../graphql/UpdatePlannerProfileCategories.graphql'
import Loader from '../../UI/Loader'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class CategoryForm extends React.Component {
  state = {
    saving: false,
    items: [
      {
        id: _.uniqueId(),
        category: null
      }
    ],
    error: '',
    routeIndex: 6
  }

  componentWillMount() {
    const categories = _.get(this, 'props.data.User.plannerProfile.categories', [])
    if (categories && categories.length) {
      const items = categories.map(category => {
        return {
          id: _.uniqueId(),
          category
        }
      })
      this.setState({ items })
    }
  }

  componentWillReceiveProps(nextProps) {
    const categories = _.get(this, 'props.data.User.plannerProfile.categories', [])
    const categoriesNext = _.get(nextProps, 'data.User.plannerProfile.categories', [])
    if (categoriesNext && categories.length !== categoriesNext.length) {
      const items = categoriesNext.map(category => {
        return {
          id: _.uniqueId(),
          category
        }
      })
      this.setState({ items })
    }
  }

  getCategoryOptions = () => {
    const { t } = this.props
    const options = []
    for (let category in CATEGORIES) {
      if (CATEGORIES.hasOwnProperty(category)) {
        options.push({
          label: t('categories:' + category),
          value: CATEGORIES[category]
        })
      }
    }
    return options
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true,
      error: ''
    })
    let categories = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'category_') {
        if (categories.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: 'Each category must be chosen once'
          })
          return
        }
        categories.push(values[item])
      }
    }
    this.props
      .updatePlannerProfile({
        variables: {
          id: this.props.data.User.plannerProfile.id,
          categories
        },
        fetchPolicy: 'no-cache'
      })
      .then(result => {
        this.setState({
          saving: false
        })
        this.props.data.refetch()
        NotificationManager.success('Categories updated', 'Success', 5000)
        this.props.history.push('/create-guru-profile/expertise')
      })
      .catch(err => {
        this.setState({
          saving: false
        })
        NotificationManager.error('Error while updating categories', 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          category: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('category_title')}</div>
        <div className="steps-screen__form-subtitle">{t('category_description_title')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName="Save & Continue"
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {this.state.items.map(el => {
                return (
                  <div key={el.id} className="removable-item-row">
                    <SelectInput
                      options={this.getCategoryOptions()}
                      id={`category_${el.id}`}
                      placeholder="Select category"
                      initialValue={el.category}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                    />
                    {this.state.items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> Remove
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> Add category (optional)
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  graphql(UPDATE_PLANNER_PROFILE_CATEGORIES_QUERY, {
    name: 'updatePlannerProfile',
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  withRouter
)
export default enhance(CategoryForm)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/CategoryForm.jsx